import { render, staticRenderFns } from "./BaseTermsCheckbox.vue?vue&type=template&id=37cce20f&"
import script from "./BaseTermsCheckbox.vue?vue&type=script&lang=js&"
export * from "./BaseTermsCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports